import { gql, QueryResult, useQuery } from "@apollo/client";

import { AssetQuery, AssetQueryResult } from "../../../generated/gql/graphql";

const GET_ASSETS = gql`
  query GetAssets($query: AssetQuery) {
    assets(query: $query) {
      items {
        id
        approval
        status
        sort
        type
        name
        image
        parentId
        categoryId
        nextAssetId
        prevAssetId
        contentAmount
        contentUnit
        favorite
        geometry
        metashotsType
        # ToDo: Pls fix endpoint expectation
        # languageRegionsId
        assetTypes
        brandId
        collectionId
        oderIndex
        dateCreated
        dateUpdated
      }
      totalCount
      page
      offset
    }
  }
`;

export default function useAssets(
  query?: AssetQuery
): QueryResult<AssetQueryResult> {
  return useQuery(GET_ASSETS, {
    variables: {
      query,
    },
    fetchPolicy: "network-only",
  });
}
